import { type ReactNode } from "react";

import {
  LoadingButtonIconFrame,
  LoadingButtonSpinner,
} from "ui/button/loading-button/loading-button.styles";
import {
  type LoadingButtonIconPhase,
  type LoadingButtonIconProps,
  LoadingButtonState,
} from "ui/button/loading-button/loading-button.types";

import Icons from "assets";

export const AsyncButtonIcon = ({
  iconPhase,
  state,
  loadingIcon,
  successIcon,
  errorIcon,
}: LoadingButtonIconProps & { iconPhase: LoadingButtonIconPhase }) => {
  const getOrExcludeIcon = (icon: ReactNode | null | undefined, defaultIcon: ReactNode) => {
    return icon === undefined ? defaultIcon : icon;
  };

  if (state === LoadingButtonState.Loading) {
    return getOrExcludeIcon(loadingIcon, <LoadingButtonSpinner />);
  }

  if (state === LoadingButtonState.Success) {
    const successIconElement = getOrExcludeIcon(successIcon, <Icons.CheckCircle />);

    return (
      successIconElement && (
        <LoadingButtonIconFrame iconPhase={iconPhase}>{successIconElement}</LoadingButtonIconFrame>
      )
    );
  }

  if (state === LoadingButtonState.Error) {
    const errorIconElement = getOrExcludeIcon(errorIcon, <Icons.ExclamationCircle />);

    return errorIconElement && <LoadingButtonIconFrame>{errorIconElement}</LoadingButtonIconFrame>;
  }

  return null;
};
